/** @jsx CanvaSX */
import { CanvaSX } from '@lib/canvasx/canvasx';
import { UserAvatar } from '../../canvasx/UserAvatar';
import {
  type AvatarStructure,
  type FieldContentsData,
} from '../../shared-types';

export interface AvatarFieldProps {
  avatar: AvatarStructure;
  contents: FieldContentsData;
  fieldId: RecordId;
}

export const AvatarField: CanvaSXFC<AvatarFieldProps> = function ({ avatar }) {
  return <UserAvatar {...avatar} size={14} />;
};
